const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "\\u043F\\u043B\\u043E\\u0449\\u0430",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M68.25,6.75v61.49H6.75V6.75h61.49M70,5H5v65h65V5h0Z",
    style: {
      fill: "#a4a4a4"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 64.43,
    y1: 10.97,
    x2: 52.78,
    y2: 22.63,
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.25 10.01 55.31 11.76 63.95 11.45 63.64 20.09 65.39 20.15 65.77 9.62 55.25 10.01",
    style: {
      fill: "#a4a4a4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 10.77,
    y1: 10.97,
    x2: 22.42,
    y2: 22.63,
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.8 20.15 11.56 20.09 11.24 11.45 19.88 11.76 19.95 10.01 9.42 9.63 9.8 20.15",
    style: {
      fill: "#a4a4a4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 64.43,
    y1: 64.28,
    x2: 52.78,
    y2: 52.63,
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.39 55.1 63.64 55.16 63.96 63.8 55.31 63.49 55.25 65.24 65.78 65.62 65.39 55.1",
    style: {
      fill: "#a4a4a4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 10.77,
    y1: 64.28,
    x2: 22.42,
    y2: 52.63,
    style: {
      fill: "none",
      stroke: "#a4a4a4",
      strokeMiterlimit: 10,
      strokeWidth: "1.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.95 65.24 19.89 63.49 11.24 63.81 11.56 55.16 9.8 55.1 9.42 65.63 19.95 65.24",
    style: {
      fill: "#a4a4a4"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetry);
export default __webpack_public_path__ + "static/media/metry.be0e584e0ba3796d8524750bfaff4db5.svg";
export { ForwardRef as ReactComponent };